export default __webpack_public_path__ + "static/media/chevron-down.acdc2264.svg";